import pseudoTranslate from '@nike/i18n-pseudo';
import localeMap from '../utils/locale-map';
import codes from './currency-codes';
import applyNumberFormatWithDangerousOverrides from './dangerous-overrides';
/**
 * This function generates a number string with the passed args *
 *
 * @param {string} locale The BCP-47 locale
 * @param {number} number The number to display
 * @param {object} options The Intl.NumberFormat options
 */
export default function numberFormat(locale, number, options = {}) {
    const finalOpts = options;
    let finalLocale = locale;
    // Removing any options that were given a null value. This mostly
    // comes from the React component
    Object.keys(finalOpts)
        .filter((key) => finalOpts[key] === null)
        .forEach((key) => delete finalOpts[key]);
    // Give an informative error if the dev passed a style option but
    // didn't pass a currency code.
    if (finalOpts.style === 'currency' && !finalOpts.currency) {
        throw new Error('You set the style option to "currency", but didn\'t pass a ' +
            'currency code in the currency option. Pro-Tip: If you pass a currency code, we ' +
            'automatically set the style option to "currency".');
    }
    // Set the style to currency if the currency option was passed
    if (finalOpts.currency) {
        finalOpts.currency = finalOpts.currency.toUpperCase();
        if (!codes.includes(finalOpts.currency)) {
            throw new Error(`The currency code "${finalOpts.currency}" is not valid. Possible ` +
                `codes are:\n${codes.join(', ')}\n\nSee full documentation here:\n` +
                'https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects' +
                '/NumberFormat');
        }
        finalOpts.style = 'currency';
    }
    // Map this locale if necessary
    if (Object.keys(localeMap).includes(locale)) {
        finalLocale = localeMap[locale];
    }
    // Fix the locale's cases
    else {
        const parts = locale.split('-');
        if (parts.length === 2) {
            finalLocale = `${parts[0].toLowerCase()}-${parts[1].toUpperCase()}`;
        }
    }
    // Generate the final number, with any overrides
    let numberOutput = applyNumberFormatWithDangerousOverrides(finalLocale, number, options);
    // Apply pseudo if necessary
    if (locale === 'pseudo') {
        numberOutput = pseudoTranslate(numberOutput);
    }
    return numberOutput;
}
//# sourceMappingURL=number.js.map